import Vue from "vue";
import Router from "vue-router";
import Layout from "@/layout/index.vue";
import {
  getToken,
  setToken,
  removeToken,
  getStoreId,
  setStoreId,
  removeStoreId,
  setUserInfo,
  getUserInfo,
  removeUserInfo
} from "@/utils/cookies";
import store from "@/store";

Vue.use(Router);

const router = new Router({
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      component: () =>
        import(/* webpackChunkName: "login" */ "@/views/login/index.vue"),
      meta: { title: "湖北省地质医院健康证管理信息系统", hidden: true, notNeedAuth: true }
    },
    {
      path: "/404",
      component: () => import(/* webpackChunkName: "404" */ "@/views/404.vue"),
      meta: { title: "湖北省地质院健康证管理信息系统", hidden: true, notNeedAuth: true }
    },
    {
      path: "/",
      component: Layout,
      redirect: "/dashboard",
      children: [
        {
          path: "dashboard",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/index.vue"),
          name: "Dashboard",
          meta: {
            title: "工作台",
            icon: "dashboard",
            affix: true
          }
        },

        {
          path: "/orderDetails/add",//新增页面路径
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/orderDetails/addMessage.vue"),
          meta: {
            title: "个人登记",
            // hidden: true
            icon: "icon-order"
          }
        },

        {
          path: "/order",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/orderDetails/index.vue"),
          meta: {
            title: "预约管理",
            icon: "icon-order"
          }
        },


        {
          path: "/category/update",//新增页面路径
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/category/updateZj.vue"),
          meta: {
            title: "修改证件信息",
            hidden: true
          }
        },


        {
          path: "dish",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/dish/index.vue"),
          meta: {
            title: "体检管理",
            icon: "icon-dish"
          }
        },

        {
          path: "category",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/category/index.vue"),
          meta: {
            title: "证件管理",
            icon: "icon-category"
          }
        },

        {
          path: "setmeal",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/setmeal/index.vue"),
          meta: {
            title: "日期管理",
            icon: "icon-combo"
          }
        },
        {
          path: "/statistics",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/statistics/index.vue"),
          meta: {
            title: "数据统计",
            icon: "icon-statistics"
          }
        },
        {
          path: "adminuser",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/adminuser/index.vue"),
          meta: {
            title: "人员管理",
            icon: "icon-employee"
          }
        },

        {
          path: "/adminuser/add",//新增页面路径
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/adminuser/addAdminUser.vue"),
          meta: {
            title: "添加账号",
            hidden: true
          }
        },
        {
          path: "test",
          component: () =>
            import(/* webpackChunkName: "test" */ "@/views/test/index.vue"),
          meta: {
            title: "测试",
            icon: "icon-order"
          }
        },
      ]
    },
    {
      path: "*",
      redirect: "/404",
      meta: { hidden: true }
    }
  ]
});

export default router;
